import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filterDispatcher, combineDispatchers,pinnedItemDispatcher, configuratorDispatcher, combineStates, configuratorState, pinnedItemsState, identityState, filterSelectedDispatcher,filterSelectedState } from '../../../../store';
import { translate } from '../../../../services';
import { SvgImage } from '../../../../components';
import { ResetIconNew, resetIcon } from '../../../../../style/images';
import { PropTypes } from 'prop-types';
import { deflateModelVariables, getPreselectionAssignments } from '../../../../util';
import { Box } from '@mui/material';

export class ResetButtonComponent extends Component {  
  getPinnedValues( configuration, pinnedValues ) {    
    const variables = deflateModelVariables( configuration.model );
    const assignments = [];
    for( let variable of variables ) {
      for( let pinnedVariable in pinnedValues ) {
        if( variable.name === pinnedVariable ) {
          const value = Object.keys( pinnedValues[pinnedVariable] ).first();
          assignments.push( { key: `${variable.group}.${variable.name}`, value } );
        }
      }
    }

    return assignments;
  }

  resetPinned = ()=>{
    this.props.deletePinnedItems( this.props.currentSelector.name );
  }

  reset = ( resetAll ) => {
    const { configurations, currentSelector, pinnedItems, user } = this.props;
    const config = configurations._active;
    if( currentSelector.isAccessories && config ) {
      const product = config[0].product;
      this.props.loadProduct( product ).then( () => {
        const pinnedAssignments = resetAll ? this.props.deletePinnedItems( product.name ) && [] 
        : pinnedItems && pinnedItems[product.name] && this.getPinnedValues( config[0], pinnedItems[product.name] ) || [];
        const preselectedAssignments = getPreselectionAssignments( config[0], currentSelector );
        const assignments = [...pinnedAssignments, ...preselectedAssignments];
        if( !assignments.length ) {
          return Promise.resolve( config[0] );
        }
        return this.props.fromTemplate( config[0], config[0], assignments );
      } ); 
    }else if ( currentSelector.type === 2 ){
     
      var sqlFilters = [];
      currentSelector.sqlFilters.forEach( filter  => {
        if( filter.property.startsWith('9AA') ){
          sqlFilters.push( filter );
        }
        else{
          filter.equalsTo = null;
          sqlFilters.push( filter );
        }
      }
      );
      currentSelector.sqlFilters = sqlFilters;
      this.props.getFilterSelectors( currentSelector, user, true );
    }else if( resetAll ) {
      this.props.deletePinnedItems( currentSelector.name );
      this.props.getFilterSelectors( currentSelector, user, true );
    }else{
      this.props.getFilterSelectors( currentSelector, user, true ).then((res=>
      {
          const selectedFilter=res?.filter(f=> f && f.values && f.values.any(v=>v.isSelected));
          if(selectedFilter && selectedFilter.length==0){
            this.props.setFilterSelected(false);
          }
          else{
            this.props.setFilterSelected(true);
          }
      }
      ));
    }
  }
  

  render() {
    const { currentSelector, pinnedItems , filterSelected} = this.props;

    let resetPinned = null
    if(pinnedItems[currentSelector?.name]){
      const currentPinned = pinnedItems[currentSelector.name] 
      for(let key in currentPinned){
        if(Object.keys(currentPinned[key]).length !== 0){
          resetPinned = <button type="button" className="reset-button" onClick={ () => this.resetPinned()}>
                          <SvgImage source={ ResetIconNew } className="reset-icon" />
                          <span>{ translate( 'Reset Pinned' ) }</span>
                        </button>
          break;
        }
      }
    }
    return !currentSelector ? null : filterSelected.show?<Box className="reset-button-container" sx={{display:{md:"flex", xs:!this.props.fromMobileFilter?"none":"flex"}, flexDirection:{md:"row-reverse", xs:"row"}, flexFlow:"wrap", gap:{md:"12px", xs:"8px"}}}>
      <button type="button" className="reset-button" onClick= { () => this.reset( false )}>
      <SvgImage source={ ResetIconNew } className="reset-icon" />
      <span>{ translate( 'Reset filter' ) }</span>
    </button>
    {/* <button type="button" className="reset-button" onClick={ () => this.reset( true )}>
    <SvgImage source={ ResetIconNew } className="reset-icon" />
    <span>{ translate( 'Reset All' ) }</span>
    </button> */}
    {resetPinned}
    </Box> :null
  }
}

ResetButtonComponent.propTypes = {
  configurations: PropTypes.shape( {
    _active: PropTypes.shape( {} )
  } ),
  currentSelector: PropTypes.shape( {} ),
  getFilterSelectors: PropTypes.func.isRequired,
  removePinnedItem: PropTypes.func.isRequired,
  pinnedItems: PropTypes.shape( {} )
};

export const ResetButton = connect( 
  combineStates( configuratorState, pinnedItemsState, identityState, filterSelectedState ), 
  combineDispatchers( configuratorDispatcher, filterDispatcher, pinnedItemDispatcher, filterSelectedDispatcher ) 
)( ResetButtonComponent );
